import { render, staticRenderFns } from "./anzahlMaengelIcon.vue?vue&type=template&id=0a6391a8&scoped=true"
import script from "./anzahlMaengelIcon.vue?vue&type=script&lang=js"
export * from "./anzahlMaengelIcon.vue?vue&type=script&lang=js"
import style0 from "./anzahlMaengelIcon.vue?vue&type=style&index=0&id=0a6391a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6391a8",
  null
  
)

export default component.exports